import { ReactNode } from "react";
import styles from "@/pages/index.module.css";

export function Ad(): ReactNode {
  return (
    <a
      href="https://slush.video?utm_source=doodlycoo"
      aria-label="slush.video - own your livestream"
      target="_blank"
    >
      <div className={styles.adContainer}>
        <div className={styles.ad}></div>
      </div>
    </a>
  );
}
